import { getField, updateField } from 'vuex-map-fields';
import dayjs from 'dayjs';

import propertyKeyDateGetters from '../utils/property-key-date-getters.js';
import tenancyKeyDateGetters from '../utils/tenancy-key-date-getters.js';

export default {
    namespaced: true,

    state: {
        property: null,
        tenancy: null,
        fixfloUrl: null,
        noteTypes: null,
        notes: null,
        workflows: null,
        workflow: null,
    },

    getters: {
        getField,
        ...propertyKeyDateGetters,
        ...tenancyKeyDateGetters,
        parsedNoteTypes: (state) => {
            let result = [];

            // turn object into array
            if(state.noteTypes && state.noteTypes.Rows && state.noteTypes.Rows.length) {
                result = state.noteTypes.Rows.map((row) => row.strLinkType);
            }

            return result;
        },
        hasNotes: (state) => {
            return (state.notes && state.notes.RowCount);
        },
        isExpiring: (state) => {
            return Boolean(state.tenancy.dteMoveOutDate || (state.tenancy.blnPeriodicTenancy === false && state.tenancy.dteVacatingDate));
        },
        endDate: (state) => {
            const date = state.tenancy.dteMoveOutDate || state.tenancy.dteVacatingDate;

            return dayjs(date);
        },
        isRenewable: (state, getters) => {
            const difference = getters.endDate.diff(dayjs(), 'day');

            return (difference > 0 && difference <= process.env.MIX_PROPERTY_EXPIRY_WARNING_DAYS);
        },
        remainingTime: (state, getters) => {
            return getters.endDate.fromNow();
        },
    },

    actions: {
        reset({ commit }) {
            commit('setProperty', null);
            commit('setTenancy', null);
            commit('setFixfloUrl', null);
            commit('setNoteTypes', null);
            commit('setNotes', null);
        },
        getRow({ commit }, propertyPK) {
            return axios.get(`/api/contacts/tenancies/properties/${propertyPK}`)
            .then((response) => {
                commit('setProperty', response.data.data);
            })
            .catch(() => {
                commit('setProperty', false);
            });
        },
        getTenancy({ commit }, tenancyPK) {
            return axios.get(`/api/contacts/tenancies/${tenancyPK}`)
            .then((response) => {
                commit('setTenancy', response.data.data);
            })
            .catch(() => {
                commit('setTenancy', false);
            });
        },
        getNoteTypes({ commit, state }) {
            commit('setNoteTypes', null);

            return axios.get(`/api/contacts/tenancies/${state.tenancy.TenancyPK}/notes/types`)
            .then((response) => {
                commit('setNoteTypes', response.data.data);
            })
            .catch(() => {
                commit('setNoteTypes', []);
            });
        },
        getNotes({ commit, state }, params) {
            commit('setNotes', null);

            return axios.get(`/api/contacts/tenancies/${state.tenancy.TenancyPK}/notes`, {
                params: params,
            })
            .then((response) => {
                commit('setNotes', response.data.data);
            })
            .catch(() => {
                commit('setNotes', []);
            });
        },
        getWorkflows({ commit, state }) {
            commit('setWorkflows', null);

            return axios.get(`/api/contacts/tenancies/${state.tenancy.TenancyPK}/workflows`)
            .then((response) => {
                commit('setWorkflows', response.data.data);
            })
            .catch(() => {
                commit('setWorkflows', []);
            });
        },
        getWorkflow({ commit, state }, workflowPK) {
            commit('setWorkflow', null);

            return axios.get(`/api/contacts/tenancies/${state.tenancy.TenancyPK}/workflows/${workflowPK}`)
            .then((response) => {
                commit('setWorkflow', response.data.data);
            })
            .catch(() => {
                commit('setWorkflow', []);
            });
        },
        requestRenewal({ state }) {
            return axios.post(`/api/contacts/tenancies/${state.tenancy.TenancyPK}/renew`);
        },
        getFixfloUrl({ commit }, tenancyFK) {
            return axios.get(`/api/contacts/tenancies/${tenancyFK}/fixflo-url`)
            .then((response) => {
                commit('setFixfloUrl', response.data.data.url);
            })
            .catch(() => {
                commit('setFixfloUrl', null);
            });
        },
    },

    mutations: {
        updateField,
        setProperty(state, property) {
            state.property = property;
        },
        setTenancy(state, tenancy) {
            state.tenancy = tenancy;
        },
        setNoteTypes(state, noteTypes) {
            state.noteTypes = noteTypes;
        },
        setNotes(state, notes) {
            state.notes = notes;
        },
        setFixfloUrl(state, url) {
            state.fixfloUrl = url;
        },
        setWorkflows(state, workflows) {
            state.workflows = workflows;
        },
        setWorkflow(state, workflow) {
            state.workflow = workflow;
        },
    },
};
